<header class="container-fluid">
  <div class="row bg-primary">
    <div class="col-12">
      <nav class="navbar navbar-expand-md navbar-dark bg-primary">
        <!-- 100% wide until md breakpoint -->
        <div class="container-fluid">
          <a class="navbar-brand" [routerLink]="['/']">
            <img
              class="img-logo"
              src="assets/img/icons/logo-header-lg.svg"
              alt="NYCHA Logo"
            />
            <!-- <img
              class="d-md-none"
              style="margin-right: 12px; margin-top: 1px"
              src="assets/img/icons/logo-header-sm.svg"
              alt="NYCHA Logo"
              width="30"
              height="36"
            /> -->
            <!-- Need to move it outside the link to avoid the user from navigatin when selection the updated date -->
            <div class="branding">
              <span class="navbar-text skiptranslate">NYCHA Capital Projects & Needs Tracker</span>
              <!-- hide on screens smaller than md -->
              <span class="test-class last-updated-lg d-none d-md-block">
                Updated Every 2 Weeks (Last Updated {{ siteUpdateDate | date: 'MMMM dd, yyyy' }})
              </span>
            </div>
          </a>

          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="translate-banner">
            <div class="language-selector">
              <div id="google_translate_element"></div>
            </div>
          </div>

          <div
            class="offcanvas offcanvas-end text-bg-primary"
            tabindex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div class="offcanvas-header">
              <button
                type="button"
                class="btn-close btn-close-dark"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>

            <div class="offcanvas-body">
              <ul class="navbar-nav justify-content-end flex-grow-1">
                <li
                  *ngIf="isMobileLayout"
                  class="nav-item"
                  routerLinkActive="activeNav"
                  [routerLinkActiveOptions]="{ exact: true }"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNavbar"
                >
                  <a
                    [routerLink]="['/']"
                    routerLinkActive="active"
                    class="nav-link"
                    aria-current="page"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    <i class="icon icon-home icon-white"></i>
                    <span>Home</span>
                  </a>
                </li>
                <li *ngIf="!isMobileLayout" class="nav-item">
                  <a
                    [routerLink]="['/']"
                    routerLinkActive="active"
                    class="nav-link"
                    aria-current="page"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    <i class="icon icon-home icon-white"></i>
                    <span>Home</span>
                  </a>
                </li>

                <li
                  *ngIf="isMobileLayout"
                  class="nav-item"
                  routerLinkActive="activeNav"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNavbar"
                >
                  <a
                    href="/assets/pdf/Infographic.pdf"
                    target="_blank"
                    routerLinkActive="active"
                    class="nav-link"
                    rel="noopener noreferrer"
                  >
                    <i class="icon icon-qa icon-white"></i>
                    <span>
                      Info<span style="font-size: 11px; margin-left: 0"> & </span>Definitions
                    </span>
                  </a>
                </li>
                <li *ngIf="!isMobileLayout" class="nav-item">
                  <a
                    href="/assets/pdf/Infographic.pdf"
                    target="_blank"
                    routerLinkActive="active"
                    class="nav-link"
                    rel="noopener noreferrer"
                  >
                    <i class="icon icon-qa icon-white"></i>
                    <span>
                      Info<span style="font-size: 11px; margin-left: 0"> & </span>Definitions
                    </span>
                  </a>
                </li>

                <li class="nav-item prind-pdf-nav-item">
                  <button class="btn btn-link nav-link" type="button" (click)="printPDF()">
                    <i class="icon icon-print icon-white"></i>
                    <span>Print PDF</span>
                  </button>
                </li>
                <li
                  *ngIf="isMobileLayout"
                  class="nav-item"
                  routerLinkActive="activeNav"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNavbar"
                >
                  <a
                    [routerLink]="['/contact']"
                    routerLinkActive="active"
                    class="nav-link"
                    aria-current="page"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    <i class="icon icon-contact icon-white"></i>
                    <span>Contact Us</span>
                  </a>
                </li>
                <li *ngIf="!isMobileLayout" class="nav-item">
                  <a
                    [routerLink]="['/contact']"
                    routerLinkActive="active"
                    class="nav-link"
                    aria-current="page"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    <i class="icon icon-contact icon-white"></i>
                    <span>Contact Us</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <!-- hide on md and wider screens -->
  <div class="row last-updated d-md-none">
    <div class="col-sm-12">
      <p>Updated Every 2 Weeks (Last Updated {{ siteUpdateDate | date: 'MMMM dd, yyyy'  }})</p>
    </div>
  </div>
</header>
